import React, { useRef, useState, useCallback, useEffect } from 'react';
import * as Scroll from 'react-scroll';

import { ColContainer } from '../atoms';
import { Header, Section } from '../molecules';
import { ISection, HeaderList } from '../../entity/type';

const scroll = Scroll.animateScroll;
const Events = Scroll.Events;

const ViewportHeight = window.visualViewport.height;

function SectionList({ list }: { list: ISection[] }) {
  const sectionsRef = useRef(new Array<HTMLDivElement | null>(list.length));
  const isScrolling = useRef(false);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [headerList, setHeaderList] = useState<HeaderList[] | null>(null);

  const handleClickHeaderItem = useCallback((index: number) => {
    setCurrentIndex(index);
    const targetYPosition =
      (sectionsRef.current[index]?.offsetTop ?? 0) + ViewportHeight;
    scroll.scrollTo(targetYPosition);
  }, []);

  useEffect(
    function getHeaderText() {
      const temp: HeaderList[] = list.map((v) => {
        let name = v.name;

        if (name.length > 8) {
          name = name.substr(0, 8);
        }

        return { name, color: v.color };
      });

      setHeaderList(temp);
    },
    [list]
  );

  useEffect(
    function handleScrolEvent() {
      function handleScroll() {
        if (isScrolling.current) {
          return;
        }

        const currentScrollY = window.scrollY - ViewportHeight;

        const newIndex = sectionsRef.current.reduce((prevIndex, section, i) => {
          if (!section) {
            return prevIndex;
          }

          if (currentScrollY + ViewportHeight / 2 >= section.offsetTop) {
            return i;
          }

          return prevIndex;
        }, 0);

        if (newIndex !== currentIndex) {
          setCurrentIndex(newIndex);
        }
      }
      window.addEventListener('scroll', handleScroll);

      return () => window.removeEventListener('scroll', handleScroll);
    },
    [currentIndex]
  );

  useEffect(function preventSetIndexByClick() {
    Events.scrollEvent.register('begin', () => {
      isScrolling.current = true;
    });

    Events.scrollEvent.register('end', () => {
      isScrolling.current = false;
    });
  }, []);

  return (
    <ColContainer
      style={{
        position: 'relative',
        zIndex: 999,
        background: 'black',
      }}
    >
      {/* <Gradient /> */}
      <Header
        currentIndex={currentIndex}
        onClickHeaderItem={handleClickHeaderItem}
        headerList={headerList}
      />

      {list.map((v, i) => {
        return (
          <Section
            ref={(element) => {
              sectionsRef.current[i] = element;
            }}
            key={i}
            section={v}
            sectionIndex={i}
          />
        );
      })}
    </ColContainer>
  );
}

export default SectionList;
